import React from 'react';
import Async from 'react-select/async';
import { clientContactStore } from 'ats/pages/clients/components/ClientContactStore';
import MultiDropdownGroupedAsync from 'ats/components/multi-dropdown-grouped/MultiDropdownGroupedAsync';

export class ClientContactsDropdown extends React.Component {
	state = {
		value: null,
		defaultOptions: [],
		loaded: false
	};
	async componentDidMount() {
		if (this.props.value) {
			this.setState({ value: this.props.value });
		}
		this.setState({ loaded: true });
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value) {
			this.setState({ value: this.props.value });
		}
		if (
			prevProps.clientId !== this.props.clientId ||
			prevProps.value !== this.props.value
		) {
			if (
				!this.props.value ||
				(Array.isArray(this.props.value) && this.props.value.length === 0)
			) {
				this.loadOptions('').then(options => {
					this.setState({ defaultOptions: options });
				});
			}
		}
	}

	render() {
		if (this.state.loaded) {
			const { isMulti } = this.props;
			// Multi-select uses the grouped async wrapper so currently selected
			// contacts are pinned at the top and the count pill is rendered.
			const Component = isMulti ? MultiDropdownGroupedAsync : Async;

			return (
				<Component
					menuPosition={this.props.menuPosition || 'fixed'}
					menuPlacement={this.props.menuPlacement || 'auto'}
					closeMenuOnScroll={this.props.closeMenuOnScroll}
					menuPortalTarget={this.props.menuPortalTarget}
					maxMenuHeight="300"
					className={
						'react-select ' +
						(isMulti ? 'ats-multi-dropdown ats-multi-dropdown-grouped ' : '') +
						(this.props.styleVersion ? this.props.styleVersion : '')
					}
					classNamePrefix={
						this.props.classNamePrefix ||
						'react-select' +
							(this.props.styleVersion ? `-${this.props.styleVersion}` : '')
					}
					cacheOptions
					value={this.state.value}
					placeholder={this.props.placeholder || 'Client Contacts'}
					isMulti={isMulti}
					required={this.props.required}
					isClearable={this.props.isClearable}
					isDisabled={this.props.disabled}
					components={{
						IndicatorSeparator: null,
						DropdownIndicator: () => (
							<img src="/ats/icons/chevron-down-icon.svg" alt="" />
						)
					}}
					styles={{
						container: (base, state) => ({
							...base,
							...(state.isDisabled && {
								opacity: 0.5,
								cursor: 'not-allowed'
							})
						}),
						control: base => ({
							...base,
							paddingRight: 12,
							...(this.props.customStyles?.control || {})
						})
					}}
					defaultOptions={this.state.defaultOptions}
					loadOptions={this.loadOptions}
					filterOption={option =>
						this.props.clientId
							? option.data.clientId === this.props.clientId
							: true
					}
					getOptionValue={this.getOptionValue}
					getOptionLabel={this.getOptionLabel}
					noOptionsMessage={this.noOptionsMessage}
					onChange={item => {
						if (this.props.onValueChange) {
							this.props.onValueChange(item);
						}
						this.setState({ value: item });
					}}
				/>
			);
		} else {
			return null;
		}
	}

	getClientContacts = async inputValue => {
		inputValue = inputValue.trim();
		const queryParams = {
			text: inputValue
		};

		if (this.props.clientId) {
			queryParams.clientId = this.props.clientId;
		}

		const result = await clientContactStore.getClientContacts(queryParams);
		return result.data.rows;
	};

	loadOptions = inputValue => {
		return this.getClientContacts(inputValue);
	};

	noOptionsMessage = value => {
		if (value.inputValue && value.inputValue.length >= 1) {
			return 'No matches found';
		} else {
			return 'Enter text to search contacts';
		}
	};

	getOptionValue = option => option.id;

	getOptionLabel = option => `${option.name}`;
}
